import React from "react";

const ContentListLoader = () => {
  return (
    <div className="bg-white">
      <div className="w-full animate-pulse">
        {[...Array(5)].map((_, index) => (
          <div key={index}>
            <div className="bg-white w-full border-solid flex py-7 px-5">
              <div className="w-[75%] block rounded mr-4">
                <div className="flex flex-col">
                  <div className="h-4 bg-gray-200 rounded w-48 mb-2"></div>
                  <div className="h-4 bg-gray-200 rounded w-64"></div>
                </div>
              </div>
              <div className="w-[20%] rounded mx-auto mr-4">
                <div className="h-4 bg-gray-200 rounded w-48 mt-3 ml-8"></div>
              </div>
            </div>
            <div className="h-[1px] bg-gray-300 w-full"></div>
          </div>
        ))}
      </div>
    </div>
  );
};

export default ContentListLoader;
